export default __webpack_public_path__ + "static/media/account-cog.d9bb2688.svg";